import { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import Form from "../../components/inputs/form";
import Textbox from "../../components/inputs/textbox";
import Submit from "../../components/inputs/submit";
import RegisterTicketApi from "../../api/register-ticket";
import AuthContext from "../../components/auth-context";
import TicketSubjectsApi from "../../api/subjects";
import useAppNavigate from "../../components/router/use-app-navigate";
import Select from "../../components/inputs/select";
import Textarea from "../../components/inputs/textarea";

interface RegisterTicketForm {
  serviceItemId: number;
  subjectId: number;
  description: string;
  title: string;
}

export default function RegisterTicket() {
  var { register, handleSubmit } = useForm<RegisterTicketForm>();
  var [subjects, setSubjects] = useState([]);
  const navigate = useAppNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>();
  const selectedServiceItemId = 12;

  const context = useContext(AuthContext),
    { activeFileId } = context;

  useEffect(() => {
    if (activeFileId) {
      const ticketSubjectsApi = new TicketSubjectsApi(context);
      ticketSubjectsApi.get(selectedServiceItemId).then((data) => {
        setSubjects(data);
      });
    }
    // eslint-disable-next-line
  }, []);

  const onSubmit: (data: any) => Promise<string> = ({
    serviceItemId,
    subjectId,
    description,
    title,
  }) => {
    setLoading(true);
    const ticketApi = new RegisterTicketApi(context);
    const { activeFileId } = context;
    return ticketApi
      .post({
        serviceItemId,
        subjectId,
        description,
        title,
        priority: 2,
        objects: {
          ObjectId1: activeFileId!,
        },
      })
      .then(({ errorMessage }) => {
        setErrorMessage(errorMessage);
        if (!errorMessage) {
          navigate("/tickets");
        }
        setLoading(false);
        return errorMessage;
      });
  };

  return (
    <Form submit={onSubmit} handleSubmit={handleSubmit}>
      {errorMessage && (
        <div className="text-red-500 text-right p-3 mb-4">{errorMessage}</div>
      )}
      <Select
        {...register("serviceItemId", { required: true })}
        label="نوع خدمت"
        options={[{ name: "پشتیبانی اینترنت", value: "12" }]}
      />
      <Select
        {...register("subjectId", { required: true })}
        label="موضوعات"
        options={[
          ...subjects.map(({ title, value }) => ({
            name: title,
            value: value,
          })),
        ]}
      />
      <Textbox {...register("title")} label="عنوان" />
      <Textarea {...register("description")} label="توضیحات" />
      <Submit loading={loading} />
    </Form>
  );
}
